import React, { useEffect } from "react"
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share"

import "./postHeader.scss"

const PostHeader = props => {
  const url = typeof window !== "undefined" ? window.location.href : ""

  return (
    <div className="post-header">
      <h1 className="post-header__headline">{props.headline}</h1>
      {props.share === true && (
        <div className="post-header__info">
          <div className="post-header__social">
            <FacebookShareButton
              className="post-header__social-button"
              url={url}
            >
              <FacebookIcon className="post-header__icon" size={24} round />
            </FacebookShareButton>
            <TwitterShareButton
              className="post-header__social-button"
              url={url}
            >
              <TwitterIcon className="post-header__icon" size={24} round />
            </TwitterShareButton>
            <LinkedinShareButton
              className="post-header__social-button"
              url={url}
            >
              <LinkedinIcon className="post-header__icon" size={24} round />
            </LinkedinShareButton>
          </div>
        </div>
      )}
    </div>
  )
}

export default PostHeader
